import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getPersonalizedTimeFormat } from "../../store/selectors/selector.configOptions.jsx";
import { formatLocalTime } from "../../utils/date.jsx";

export const FormatLocalTime = ({ value }) => {
  const format = useSelector(getPersonalizedTimeFormat);

  const formattedValue = useMemo(() => {
    return formatLocalTime(value, format);
  }, [value, format]);

  return formattedValue;
};

FormatLocalTime.propTypes = {
  value: PropTypes.number.isRequired,
};
